export default "__VITE_ASSET__Dxc4yM79__"